// @ts-nocheck
import React from 'react';
import { motion } from 'framer-motion';
import servicesImage from '../assets/services.png';

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6 }
  }
};

const floatingAnimation = {
  y: [0, -10, 0],
  rotate: [0, 2, -2, 0],
  scale: [1, 1.02, 1],
  transition: {
    duration: 4,
    repeat: Infinity,
    ease: "easeInOut"
  }
};

// Function to scroll to contact section in the footer
const scrollToContact = () => {
  const footerSection = document.getElementById('footer-section');
  if (footerSection) {
    footerSection.scrollIntoView({ behavior: 'smooth' });
  }
};

const ServicesSection = () => {
  return (
    <section id="services" className="section bg-black relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-primary/5 rounded-full filter blur-[100px]"></div>
        <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-primary/10 rounded-full filter blur-[100px]"></div>
      </div>
      
      <div className="container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true, margin: "-100px" }}
          className="text-left mb-16 max-w-[1186px]"
        >
          <motion.h2 
            variants={fadeInUp}
            className="text-gray-500 text-lg md:text-2xl font-semibold uppercase tracking-wider mb-4"
          >
            Services
          </motion.h2>
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-montserrat font-semibold leading-tight md:leading-snug tracking-normal mt-4 md:mt-[38px]">
            Tailored solutions to help startups thrive and reach their full potential.
          </h2>
        </motion.div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Service Content */}
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={{
              hidden: { opacity: 0 },
              visible: {
                opacity: 1,
                transition: {
                  staggerChildren: 0.2
                }
              }
            }}
            className="p-0"
          >
            <motion.h3 
              variants={fadeInUp}
              className="text-xl md:text-3xl font-montserrat font-medium leading-tight tracking-normal text-white mb-4"
            >
              TAILORED FUND OPPORTUNITY RESEARCH
            </motion.h3>
            
            <motion.p 
              variants={fadeInUp}
              className="text-base md:text-2xl mt-4 md:mt-[68px] font-montserrat font-normal leading-relaxed tracking-normal text-text-secondary"
            >
              Finding the right funding can be challenging. We conduct in-depth research to identify grants, investors, and funding opportunities tailored to your project's needs. Get a detailed report with application guidelines and recommendations.
            </motion.p>
            
            <motion.div variants={fadeInUp} className="mt-6">
              <button className="btn bg-black text-white hover:bg-black/80 border border-white" onClick={scrollToContact}>
                Get Started
              </button>
            </motion.div>
          </motion.div>
          
          {/* Image Element */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, margin: "-100px" }}
            className="relative hidden lg:flex justify-center"
          >
            <div className="relative w-[400px] h-[400px]">
              <motion.img
                src={servicesImage}
                alt="Services Illustration"
                className="w-full h-full object-contain drop-shadow-[0_0_15px_rgba(37,99,235,0.5)]"
                initial={{ opacity: 0, scale: 0.8, rotate: -5 }}
                whileInView={{ 
                  opacity: 1, 
                  scale: 1, 
                  rotate: 0,
                  transition: {
                    duration: 1,
                    ease: "easeOut"
                  }
                }}
                animate={floatingAnimation}
              />
              {/* Background glow */}
              <motion.div 
                className="absolute inset-0 -z-10 bg-gradient-to-br from-primary/10 to-transparent rounded-full blur-3xl"
                animate={{
                  scale: [1, 1.2, 1],
                  opacity: [0.5, 0.8, 0.5],
                }}
                transition={{
                  duration: 4,
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection; 